// /* eslint-disable import/no-extraneous-dependencies */
// import React from 'react';
// import { Document, Page } from 'react-pdf';

// const Base64ToPdf = ({ url }) => {
//   const base64String = url; // Replace this with your actual Base64 string
//   const [pdfData, setPdfData] = React.useState(null);
//   React.useEffect(() => {
//     const binaryString = atob(base64String);
//     const uint8Array = new Uint8Array(binaryString.length);
//     for (let i = 0; i < binaryString.length; i + 1) {
//       uint8Array[i] = binaryString.charCodeAt(i);
//     }
//     setPdfData(uint8Array);
//   }, [base64String]);
//   return (
//     <div>
//       Base64ToPdf{' '}
//       <div>
//         <h1>PDF Viewer</h1>
//         {pdfData ? (
//           <Document file={{ data: pdfData }}>
//             <Page pageNumber={1} />
//           </Document>
//         ) : (
//           <p>Loading...</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Base64ToPdf;

import React from 'react';
import { resolvePdfSource } from 'utils/pdfDownload';

const Base64ToPdf = ({ url }) => {
  const dataUri = resolvePdfSource(url);

  if (!dataUri) {
    return <p className="mb-0">Invoice document is not available.</p>;
  }

  return (
    <div>
      {/* <h1>PDF Viewer</h1> */}
      <iframe
        title="pdf"
        id="invoice-pdf"
        src={dataUri}
        height="500"
        width="100%"
      />
    </div>
  );
};

export default Base64ToPdf;
